import { render, staticRenderFns } from "./ResourceUnitCostsPage.vue?vue&type=template&id=3dc2aa83&scoped=true"
import script from "./ResourceUnitCostsPage.vue?vue&type=script&lang=ts"
export * from "./ResourceUnitCostsPage.vue?vue&type=script&lang=ts"
import style0 from "./ResourceUnitCostsPage.vue?vue&type=style&index=0&id=3dc2aa83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc2aa83",
  null
  
)

export default component.exports